export const LOAD_ITEM_POOL_AJAX_SUCCESS = "LOAD_ITEM_POOL_AJAX_SUCCESS";
export const SAVE_ITEM_POOL_SEARCH_CRITERIA = "SAVE_ITEM_POOL_SEARCH_CRITERIA";
export const DELETE_ITEM_POOL_AJAX_SUCCESS = "DELETE_ITEM_POOL_AJAX_SUCCESS";
export const EDIT_ITEM_POOL_AJAX_SUCCESS = "EDIT_ITEM_POOL_AJAX_SUCCESS";
export const SAVE_ITEM_POOL_AJAX_SUCCESS = "SAVE_ITEM_POOL_AJAX_SUCCESS";
export const ADD_ITEM_POOL = "ADD_ITEM_POOL";
export const CLEAR_OUT_IMPORT_MESSAGE = "CLEAR_OUT_IMPORT_MESSAGE";
export const IMPORT_ITEM_PARAMETER_AJAX_SUCCESS = "IMPORT_ITEM_PARAMETER_AJAX_SUCCESS";
export const IMPORT_ITEM_PARAMETER_ERRORS_AJAX_SUCCESS = "IMPORT_ITEM_PARAMETER_ERRORS_AJAX_SUCCESS";